export enum ResultAction {
  "Immediately" = "immediately",
  "Mid-term solution" = "mid_term_solution",
  "Long-term solution" = "long_term_solution",
}
